require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-khhhhhht-bucharest-we-have-a-problem.json") })
        }
      }, "path---authors-khhhhhht-bucharest-we-have-a-problem");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-khhhhhht-bucharest-we-have-a-problem!./.cache/json/authors-khhhhhht-bucharest-we-have-a-problem.json
// module id = 1303
// module chunks = 231608221292675